import {
  orderList,
  orderDetail,
  refundRecordList,
  refundOrderApprovate,
  businessStatistics
} from '@/api/sys.order'

export default {
  namespaced: true,
  actions: {
    /**
         * 分页查询
         */
    orderList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return orderList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    refundRecordList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return refundRecordList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    orderDetail ({
      dispatch
    }, {
      vm,
      data
    }) {
      return orderDetail(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    refundOrderApprovate ({
      dispatch
    }, {
      vm,
      data
    }) {
      return refundOrderApprovate(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    businessStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return businessStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
